// initial state
const state = {
    projects: [],
    currentProject: 0,
    nextProjectColor: 'white'
}

// getters
const getters = {
    project: state => slug => state.projects.slice().find(p => p.fields.slug === slug),
    projectIdBySlug: (state, getters) => slug => getters.list.findIndex(project => project.fields.slug === slug),
    currentProject: state => state.currentProject,
    prevProject: (state, getters) => slug => {
        let index = getters.list.findIndex(p => p.fields.slug === slug) - 1
        index = index < 0 ? state.projects.length - 1 : index
        return getters.list[index]
    },
    nextProject: (state, getters) => slug => {
        let index = getters.list.findIndex(p => p.fields.slug === slug) + 1
        index = index === state.projects.length ? 0 : index
        return getters.list[index]
    },
    prevProjectById: (state, getters) => i => {
        const index = i - 1 < 0 ? state.projects.length - 1 : i - 1
        return getters.list[index]
    },
    nextProjectById: (state, getters) => i => {
        const index = i + 1 === state.projects.length ? 0 : i + 1
        return getters.list[index]
    },
    list: state => {
        return state.projects.slice().sort((a, b) => {
            return a.fields.order - b.fields.order
        })
    },
    nextProjectColor: state => state.nextProjectColor
}

// actions
const actions = {
    addProject({ commit }, project) {
        commit('ADD_PROJECT', project)
    },
    updateCurrentProject({ commit }, index) {
        commit('UPDATE_CURRENT_PROJECT', index)
    },
    updateNextProjectColor({ commit }, color) {
        commit('UPDATE_NEXT_PROJECT_COLOR', color)
    }
}

// mutations
const mutations = {
    ADD_PROJECT(state, project) {
        state.projects.push(project)
    },
    UPDATE_CURRENT_PROJECT(state, index) {
        state.currentProject = index
    },
    UPDATE_NEXT_PROJECT_COLOR(state, color) {
        state.nextProjectColor = color
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/projects.js